import React from 'react';
import './TitleValueStyles.css';
import { classNames } from 'primereact/utils';

export interface ITitleValueProps {
  containerClassName?: string;
  title: string;
  value: string | number;
}
export const TitleValue: React.FC<ITitleValueProps> = ({
  containerClassName = '',
  title,
  value,
}) => {
  return (
    <div className={classNames('tvHorizontalContainer', containerClassName)}>
      <p className="tvTitle">{title}</p>
      <p className={classNames('tvValue', 'boldText')}>{value ?? 'Unknown'}</p>
    </div>
  );
};
export default TitleValue;
